import React, { Component } from 'react'
import withFilterOptions from '../../hocs/withFilterOptions'
import withItems from '../../hocs/withItems'
import { Select, Spin, Button, Icon } from 'antd'
import { getAttribute, getModelName } from '../../utils/models'
import ShowModal from '../../containers/ShowModal'
import Format from '../../containers/Format'
import FormItem from '../FormItem'

import './index.css'

const Option = Select.Option

class Collection extends Component {

    render() {
        const { getFieldDecorator } = this.props.form
        const attribute = getAttribute(this.props.model, this.props.attribute)
        const modelName = getModelName(this.props.model, this.props.attribute)
        return (
            <FormItem {...this.props}>
                {getFieldDecorator(this.props.attribute, this.props.fieldSettings)(
                    <Select
                        size='large'
                        disabled={this.props.disabled}
                        style={{ width: '100%' }}
                        allowClear={!attribute.required}
                        onChange={this.props.handleChange}
                        onDeselect={(val) => { console.info(val) }}
                        mode={'multiple'}
                        filterOption={this.props.filterOption}
                        showSearch
                        notFoundContent={this.props.fetching ? <Spin size="small" /> : (this.props.onlyNewItems ? null : 'Not found')}
                    >
                        {this.props.items.map((item, index) => (
                            <Option key={index} value={item.id}>
                                <Format
                                    model={this.props.model}
                                    attribute={this.props.attribute}
                                    value={item}
                                />
                            </Option>
                        ))}
                    </Select>
                )}
                {
                    (!this.props.hasOwnProperty('showAdd') || this.props.showAdd) &&
                    <ShowModal
                        type="form"
                        model={modelName}
                        belongsTo={this.props.belongsTo}
                    >
                        <div className="input-add-button">
                            <Button type="dashed"><Icon type="plus" /></Button>
                        </div>
                    </ShowModal>
                }
            </FormItem>
        )
    }

}

export default (
    withFilterOptions(
        withItems(Collection)
    )
)


// WEBPACK FOOTER //
// ./src/inputs/Collection/index.js